<template>
    <div class="single-card">
        <h2>Entrar</h2>
        <button @click="authGoogle()" type="button" class="button" style="background: #4285f4; width: 100%;margin-bottom: 15px;">
            <i class="mdi mdi-google"></i> Conectar com Google
        </button>
        <button @click="authFacebook" type="button" class="button" style="margin: 0; background: #4267B2; width: 100%;margin-bottom: 15px;">
            <i class="mdi mdi-facebook"></i> Conectar com Facebook
        </button>
        <p style="text-align: center">OU</p>
        <form @submit.prevent="login">
            <div class="form-group" :class="{ 'form-group--error': $v.email.$error }">
                <input class="form__input" id="email" v-model.trim="$v.email.$model"/>
                <label class="form__label" for="email" :class="{'up': $v.email.$model }">E-mail</label>
                <div class="error" v-if="!$v.email.required && $v.email.$error">E-mail é obrigatório</div>
                <div class="error" v-if="!$v.email.email && $v.email.$error">E-mail inválido</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.password.$error }">
                <input class="form__input" id="password" type="password" v-model.trim="$v.password.$model"/>
                <label class="form__label" for="password" :class="{'up': $v.password.$model }">Senha</label>
                <div class="error" v-if="!$v.password.required && $v.password.$error">Senha é obrigatório</div>
                <div class="error" v-if="!$v.password.minLength && $v.password.$error">Senha deve conter pelo menos {{$v.password.$params.minLength.min}} caracteres.</div>
            </div>

            <button class="button" type="submit" :disabled="submitStatus === 'PENDING'">Entrar</button>
            <!-- <p class="typo__p" v-if="submitStatus === 'OK'"></p> -->
            <p class="typo__p" v-if="submitStatus === 'ERROR'">Por favor, preencha todos os campos corretamente.</p>
            <p class="typo__p" v-if="submitStatus === 'PENDING'">Processando...</p>
            <router-link to="/cadastrar">Não tem uma conta, cadastre-se</router-link>
        </form>
                <!-- <div><pre>{{ $v | json }}</pre></div> -->

    </div>
</template>
<script>
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
    name: "Login",
    data(){
        return{
            submitStatus: null,
            email: "",
            password: ""
        }
    },
    validations: {
        email: {
            required,
            email
        },
        password: {
            required,
            minLength: minLength(2)
        },
        
    },
    methods: {
        login(){
            this.$firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
                (data) => { 
                    let user = {
                        name: data.user.displayName,
                        email: data.user.email,
                        verified: data.user.emailVerified, 
                        phone: data.user.phoneNumber,
                        photo: data.user.photoURL, 
                    }
                    this.$user = user
                    this.$router.replace('verificando')
                },
                (err) => {
                    this.$root.alerts.push({msg: err.message, type: 'error'})
                }
            )
        },
        authGoogle(){
            this.$firebase.auth().signInWithPopup(new this.$firebase.auth.GoogleAuthProvider).then(
                (data) => { 
                    console.log(user)
                    let user = {
                        name: data.user.displayName,
                        email: data.user.email,
                        verified: data.user.emailVerified, 
                        phone: data.user.phoneNumber,
                        photo: data.user.photoURL, 
                    }
                    this.$root.user = user
                    this.$router.replace('verificando')
                },
                (err) => {
                    this.$root.alerts.push({msg: err.message, type: 'error'})
                }
            )
        },
        authFacebook(){
            this.$firebase.auth().signInWithPopup(new this.$firebase.auth.FacebookAuthProvider).then(
                (data) => { 
                    console.log(user)
                    let user = {
                        name: data.user.displayName,
                        email: data.user.email,
                        verified: data.user.emailVerified, 
                        phone: data.user.phoneNumber,
                        photo: data.user.photoURL, 
                    }
                    this.$root.user = user
                    this.$router.replace('verificando')
                },
                (err) => {
                    this.$root.alerts.push({msg: err.message, type: 'error'})
                }
            )
        }
    }
}
</script>
<style scoped>
    a{
        color: #909090;
        text-decoration: none;
        text-align: center;
        font-size: .83em;
        padding: 10px 10px 20px 10px;
        display: block;
    }
</style>